import { Component, ContentChild, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-container',
  templateUrl: './card-container.component.html',
  styleUrls: ['./card-container.component.scss'],
  standalone: false,
})
export class CardContainerComponent implements OnInit {
  @Input() cardType: string;
  @Input() title: string;
  @Input() description: string;
  @Input() list: [];
  @Input() data: [];

  // Custom override css
  @Input() containerBackgroundCss: string;
  @Input() showTitle = true;
  @Input() showDescription = true;
  @Input() additionalCSS: string;

  // The content child allows to inject custom content into the card container
  @ContentChild('cardContainer', { static: true }) contentElement: ElementRef;

  constructor() {}

  /**
   * Default On Init
   */
  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
